import { Box, styled } from "@mui/material";

export const StyledMessageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',
    maxWidth: 720,
    margin: '0 auto',
    height: '100%',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2),
  }));
  
  export const StyledMessageBubble = styled("div")<{ fromUser?: boolean }>(
    ({ theme, fromUser }) => {
      const isDark = theme.palette.mode === 'dark';
  
      return {
        padding: theme.spacing(1.5, 2),
        margin: theme.spacing(1, 0),
        maxWidth: fromUser ? '75%' : '85%',
        alignSelf: fromUser ? 'flex-end' : 'flex-start',
        borderRadius: fromUser
          ? '16px 16px 4px 16px'
          : '16px 16px 16px 4px',
        backgroundColor: fromUser
          ? isDark
            ? 'rgba(99, 102, 241, 0.15)'
            : 'rgba(15, 23, 42, 0.03)'
          : 'transparent',
        color: isDark
          ? theme.palette.primary.main
          : theme.palette.grey[800],
        boxShadow: fromUser 
          ? isDark
            ? '0 2px 8px rgba(99, 102, 241, 0.1)'
            : '0 2px 8px rgba(15, 23, 42, 0.05)'
          : 'none',
        fontSize: '0.95rem',
        lineHeight: 1.6,
        wordBreak: 'break-all',
        overflowWrap: 'break-word',
        hyphens: 'auto',
        whiteSpace: 'pre-line',
        backdropFilter: fromUser ? 'blur(8px)' : 'none',
        border: fromUser 
          ? isDark
            ? '1px solid rgba(99, 102, 241, 0.2)'
            : '1px solid rgba(15, 23, 42, 0.08)'
          : 'none',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: fromUser 
            ? isDark
              ? '0 4px 12px rgba(99, 102, 241, 0.15)'
              : '0 4px 12px rgba(15, 23, 42, 0.08)'
            : 'none',
          transform: fromUser ? 'translateY(-1px)' : 'none',
        },
      };
    }
  );
  
  
  
  export const StyledImage = styled('img')(({ theme }) => ({
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    borderRadius: 12,
    objectFit: 'cover',
    marginTop: theme.spacing(2),
  }));